import React, { useCallback, useEffect, useRef } from 'react';
import { components, MenuProps } from 'react-select';
import { Option } from '../../../admin-dashboard-tables/interfaces';

const MenuWithFooterButton: React.FC<MenuProps<Option, false>> = ({
  children,
  ...props
}) => {
  // TODO: Figure out if these can be typed
  const {
    onPressFooterButton,
    footerButtonText = '',
    hideFooterButton,
  } = props.selectProps;

  const buttonRef: React.MutableRefObject<HTMLButtonElement | null> = useRef(null);

  useEffect(() => {
    // There appears to be a bug in React Select that causes touch events to close the menu before
    // the button within the menu can be clicked, whenever the menu is open but not focused.
    // This then causes any element rendered beneath the button to receive a "click" event.
    // In order to prevent this, we can override the touch event on the button and programmatically
    // "click" the button.
    const onTouchButton = (e) => {
      e.preventDefault();
      e.target.click();
    };

    if (buttonRef?.current) {
      buttonRef.current?.addEventListener('touchstart', onTouchButton, { passive: false });
    }
    return () => {
      buttonRef.current?.removeEventListener('mousedown', onTouchButton);
    };
  }, []);

  const onButtonPress = useCallback(() => {
    if (onPressFooterButton) {
      onPressFooterButton();
    }
  }, [onPressFooterButton]);

  return (
    <components.Menu
      {...props}
    >
      <>
        {children}
        <div className={`menu-with-footer-button border-top p-2 ${hideFooterButton ? 'd-none' : 'd-flex'}`}>
          <button
            ref={buttonRef}
            type="button"
            className="btn btn-blue-500 rounded-lg font-weight-semibold px-5"
            onClick={onButtonPress}
          >
            {footerButtonText}
          </button>
        </div>
      </>
    </components.Menu>
  );
};

export default MenuWithFooterButton;
